import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { captureAttributionUtmFromLocation } from "@/shared/lib/attributionUtm";
import { getSessionStartTs } from "@/shared/lib/analyticsSession";
import { installGlobalErrorHandlers } from "@/shared/lib/logtail";
import { AppErrorBoundary } from "@/shared/components/AppErrorBoundary";
import { SeoRouteDefaults, StagingNoindex } from "@/shared/components/Seo";
import { initTelegramViewport } from "@/shared/lib/telegramViewport";
import { isTelegramMiniApp } from "@/shared/lib/telegram";
import { isMaxMiniApp } from "@/shared/lib/max";
import { isMiniAppShell } from "@/shared/lib/appShell";
import { INITIAL_IS_DEBUG_LAUNCH } from "@/shared/lib/debugLaunch";
import { PrerenderRouteGuard, discardSnapshot, hasStoredAccountSession, isStaticHidden, prepareAppContainer, readSnapshot, resolveSnapshotMode, } from "@/shared/lib/prerenderBoot";
import App from "./app/App";
import "./app/styles/main.scss";
// Мониторинг ошибок в BetterStack — включается, если в .env задан
// BETTERSTACK_SOURCE_TOKEN. Регистрируем обработчики до первого рендера,
// чтобы ловить ошибки и в инициализации App.
installGlobalErrorHandlers();
// Подстраховка: если utm-захват выбросит синхронно — не валим всё приложение.
try {
    captureAttributionUtmFromLocation();
    // Фиксируем момент старта сессии как можно раньше (t0): якорные события
    // guest_started/login штампуются им и должны идти в таймлайне перед первым
    // web_open/page_view, которые сработают позже при рендере.
    getSessionStartTs();
}
catch (error) {
    // eslint-disable-next-line no-console
    console.error("captureAttributionUtmFromLocation failed:", error);
}
// Фуллскрин на мобилке + safe-area Telegram. Запускаем ДО первого рендера и вне
// React: чем раньше уйдёт `requestFullscreen`, тем меньше видно «прыжок»
// раскладки, а инсеты нужны уже первому кадру. Модуль сам дожидается моста
// (он грузится `async`) и сам решает, телеграмный ли это контекст, поэтому от
// авторизации и от того, какой шелл выбран, не зависит. Cleanup не нужен —
// подписки живут столько же, сколько вкладка.
try {
    initTelegramViewport();
}
catch (error) {
    // eslint-disable-next-line no-console
    console.error("initTelegramViewport failed:", error);
}
// Снимок пререндера: nginx отдаёт готовый HTML всем, в `#root` уже лежит
// статика. Либо подменяем её живым деревом без мигания (React рендерится в
// контейнер вне документа и заменяет статику, когда страница готова), либо —
// если этому посетителю она не подходит — чистим и стартуем как раньше.
// См. shared/lib/prerenderBoot.tsx и docs/SEO.md.
const rootEl = document.getElementById("root");
let appContainer = rootEl;
try {
    const isMiniApp = isTelegramMiniApp() || isMaxMiniApp();
    appContainer = prepareAppContainer(rootEl, resolveSnapshotMode({
        snapshot: readSnapshot(rootEl),
        staticHidden: isStaticHidden(),
        pathname: window.location.pathname,
        isMiniApp,
        isMiniAppShell: isMiniAppShell(),
        isDebugLaunch: INITIAL_IS_DEBUG_LAUNCH,
        hasAccountSession: hasStoredAccountSession(),
    }));
}
catch (error) {
    // eslint-disable-next-line no-console
    console.error("prerender boot failed:", error);
    appContainer = discardSnapshot(rootEl);
}
const root = ReactDOM.createRoot(appContainer);
root.render(_jsxs(React.StrictMode, { children: [_jsx(StagingNoindex, {}), _jsx(AppErrorBoundary, { children: _jsxs(BrowserRouter, { children: [_jsx(PrerenderRouteGuard, {}), _jsx(SeoRouteDefaults, {}), _jsx(App, {})] }) })] }));
